/**
 * 폼 검증에 걸렸을 때 사용자에게 보여줄 문장을 만든다.
 *
 * formik 은 검증에 걸리면 저장을 하지 않고 그냥 아무 일도 하지 않는다.
 * 각 항목 아래에 메시지가 뜨긴 하지만, 그 항목이 화면에 안 그려져 있으면
 * (조건부로 감춰진 칸, 접혀 있는 영역, 스크롤 밖) 아무것도 안 보인다.
 * 사용자 입장에서는 저장 버튼이 죽은 것처럼 보인다.
 *
 * 그래서 걸린 항목을 모아 한 번에 알려준다.
 */

/** 수주품의서 화면의 항목 이름. 여기 없는 항목은 필드명 그대로 나간다. */
export const ORDER_FIELD_LABELS = {
  expDay: '계약 시작일',
  siDt: '계약 완료일',
  mtnFreeStrtDt: '무상유지보수 시작일',
  mtnFreeEndDt: '무상유지보수 종료일',
  licStrtDt: '라이선스 시작일',
  licEndDt: '라이선스 종료일',
  dlvryDuedate: '납품 기한',
  mtnFreeTm: '무상유지보수 기간',
  inspectCond: '검수 조건',
  collCondt: '수금 조건',
  payCondt: '지급 조건',
  comment: '비고',
  roProfitAmt: '매출이익',
  roCostAmt: '영업비용',
  roInternalCosts: '협업 원가',
};

/**
 * yup 이 돌려주는 기본 메시지는 영어다("must be a `date` type ...").
 * 날짜를 지웠을 때 주로 나오는데, 그대로 보여주면 무슨 말인지 알 수 없다.
 */
const readable = (label, message) => {
  const text = String(message || '');
  if (/must be a `date` type|Invalid Date/i.test(text)) {
    return `${label}: 날짜를 다시 선택하세요`;
  }
  if (/must be a `number` type/i.test(text)) {
    return `${label}: 숫자만 입력하세요`;
  }
  return text.includes(label) ? text : `${label}: ${text}`;
};

/**
 * @param {object} errors formik.errors
 * @param {object} labels 필드명 → 화면에 쓰는 이름
 * @returns {string} 줄바꿈으로 이어붙인 안내문. 걸린 게 없으면 빈 문자열.
 */
export const describeFormErrors = (errors, labels = {}) => {
  const lines = [];

  const walk = (value, path) => {
    if (!value) return;

    if (typeof value === 'string') {
      const key = path.split('.')[0].split('[')[0];
      lines.push(readable(labels[key] || key, value));
      return;
    }

    // 배열 항목(협업 원가 등)은 몇 번째 줄인지까지 알려준다.
    if (Array.isArray(value)) {
      value.forEach((item, index) => walk(item, `${path}[${index + 1}]`));
      return;
    }

    Object.keys(value).forEach((key) => {
      walk(value[key], path ? `${path}.${key}` : key);
    });
  };

  walk(errors, '');

  if (lines.length === 0) return '';
  return `아래 항목 때문에 저장하지 못했습니다.\n\n${[...new Set(lines)].join('\n')}`;
};
